// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__R1NUj","savePackageButton":"ClientWallet_savePackageButton__12Iq8"};